"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ServiceRegistry = _interopRequireDefault(require("../../util/ServiceRegistry"));
var _Events = require("../../constants/Events");
var _LoggingUtil = _interopRequireDefault(require("../../util/LoggingUtil"));
var _AppConstants = _interopRequireDefault(require("../../constants/AppConstants"));
var _EditUtil = require("../../util/EditUtil");
var _CallbackTypes = _interopRequireWildcard(require("../../constants/CallbackTypes"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

class EditHandlerService {
  constructor() {
    this.loggingService = _ServiceRegistry.default.getService("LoggingService");
    // eslint-disable-next-line max-len
    const appStore = _ServiceRegistry.default.getService("AppStore");
    appStore.getAppReadyPromise().then(() => {
      this.setEditConfig();
    }).catch(error => {
      (0, _LoggingUtil.default)(`error is: ${error}`);
    });
  }
  setEditConfig() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    appStore.getAppRenderingDonePromise().then(() => {
      const validationService = _ServiceRegistry.default.getService("ValidationService");
      _ServiceRegistry.default.getService("EventsService").registerEventListener(_Events.FilePreviewEvents.HANDLE_ENTER_EDIT, eventData => {
        if (eventData.clientName === "crop" || eventData.clientName === "numberPage") {
          return;
        }
        if (validationService.validateOpenEditConfig()) {
          if (eventData.opts.context) {
            // eslint-disable-next-line no-param-reassign
            eventData.opts.context = _AppConstants.default.CONTEXT;
          }
          appStore.executeActionOpts = eventData.opts;
          (0, _EditUtil.triggerAsyncEvent)(_CallbackTypes.EditEventTypes.EDIT_TRIGGERED, _CallbackTypes.default.EDIT_EVENT_HANDLER).then(res => {
            if (res !== null) {
              _ServiceRegistry.default.getService("DropinService").executeDropin(_AppConstants.default.EDIT_WORKFLOW.DROPIN);
            }
          }).catch(error => {
            (0, _LoggingUtil.default)(`error is: ${error}`);
            this.loggingService.error("ToolsBoard", "Error in loading Toolsboard edit component dropin", error);
          });
        }
      });
      this.setSecondaryHeaderConfig();
      this.setToolsBoardInitializationConfig();
      _ServiceRegistry.default.getService("ToolsBoardService").initialize();
    });
  }
  setSecondaryHeaderConfig() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    const secondaryHeaderConfig = {
      dropinId: _AppConstants.default.EDIT_WORKFLOW.SECONDARY_COMPONENT.DROPINID,
      methodName: _AppConstants.default.EDIT_WORKFLOW.SECONDARY_COMPONENT.METHOD_NAME,
      options: _AppConstants.default.EDIT_WORKFLOW.SECONDARY_COMPONENT.OPTS
    };
    appStore.setSecondaryHeaderToolsConfig(secondaryHeaderConfig);
  }
  setToolsBoardInitializationConfig() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    const toolsBoardInitializationConfig = {
      dropinLoadClass: _AppConstants.default.EDIT_WORKFLOW.TOOLSBOARD_CONFIG.DROPIN,
      megaVerb: _AppConstants.default.EDIT_WORKFLOW.TOOLSBOARD_CONFIG.MEGA_VERB,
      id: _AppConstants.default.EDIT_WORKFLOW.TOOLSBOARD_CONFIG.ID,
      headerTitle: _AppConstants.default.EDIT_WORKFLOW.TOOLSBOARD_CONFIG.HEADER_TITLE,
      dropinVerb: "edit-pdf-viewer",
      context: "edit-pdf",
      selectionName: "edit-pdf"
    };
    appStore.setToolsBoardInitializationConfig(toolsBoardInitializationConfig);
  }
}
exports.default = EditHandlerService;